import React, { useEffect, useState } from 'react';
import { ErrorIcon, Logo } from '../../Assets';
import { ValidatorForm } from 'react-form-validator-core';
import { Button, Input } from '../../Atoms';
import useToaster from '../../components/Toaster/useToaster';
import { verify } from '../../redux/actions/AuthenticationAction';
import { connect } from 'react-redux';
import { getQueryStringValue } from '../../utils/helper';

const Verify = ({ verifyPassword, verify: { loading, success, error } }) => {
  const { toast } = useToaster();
  const [formData, setFormData] = useState({ password: '' });

  const handleSubmit = () => {
    const token = getQueryStringValue('token');
    verifyPassword({ password: formData.password, token });
  };

  const handleChange = ({ target: { name, value } }) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleClear = () => {
    setFormData({ password: '' });
  };

  useEffect(() => {
    if (success) {
      toast({ text: 'Your password has been updated' });
      handleClear();
      localStorage.clear();
      window.location = '/login';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  return (
    <div className="login-wrapper">
      <div className="login-form">
        <Logo />
        <div className="heading">New Password</div>
        {error && (
          <div className="error-wrapper">
            <div>
              <ErrorIcon />
            </div>
            <span>{error}</span>
          </div>
        )}
        <ValidatorForm onSubmit={handleSubmit} className="form">
          <Input
            onChange={handleChange}
            type="password"
            value={formData.password}
            title="New Password"
            placeholder="Enter New Password"
            name="password"
            validators={['required']}
            errorMessages={['this field is required']}
            formValid={!error}
          />
          <div className="action-btn">
            <Button type="button" size="sm" color="grey" onClick={handleClear}>
              Cancel
            </Button>
            <Button type="submit" size="sm" color="blue" loading={loading}>
              Submit
            </Button>
          </div>
        </ValidatorForm>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  verify: state.auth.verify,
});

const mapDispatchToProps = (dispatch) => ({
  verifyPassword: (details) => {
    dispatch(verify(details));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Verify);
